import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type SubmitAccessRequestMutationVariables = Types.Exact<{
  input: Types.SubmitAccessRequestInput;
}>;


export type SubmitAccessRequestMutation = { __typename?: 'Mutation', submitAccessRequest?: { __typename?: 'AccessRequestPayload', accessRequest?: { __typename?: 'AccessRequest', id?: string | null } | null } | null };


export const SubmitAccessRequest = /*#__PURE__*/ gql`
    mutation SubmitAccessRequest($input: SubmitAccessRequestInput!) {
  submitAccessRequest(input: $input) {
    accessRequest {
      id
    }
  }
}
    ` as unknown as DocumentNode<SubmitAccessRequestMutation, SubmitAccessRequestMutationVariables>;

          

          export const useSubmitAccessRequestMutation = (options?:MutationHookOptions<SubmitAccessRequestMutation, SubmitAccessRequestMutationVariables>) => useMutation(SubmitAccessRequest, options);
          

          export type SubmitAccessRequestMutationOptions = MutationHookOptions<SubmitAccessRequestMutation, SubmitAccessRequestMutationVariables>;

          

          export type SubmitAccessRequestMutationResult = ReturnType<typeof useSubmitAccessRequestMutation>[1];

          
